module.exports = __webpack_public_path__ + "fonts/Libre_Franklin-400-latin6.c0aa69c.woff2";